module.exports = __webpack_public_path__ + "static/img/mark3.90e77e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/markdown/mark3.png
// module id = nUT+
// module chunks = 0